import CategoricalScheme from '../../CategoricalScheme';

const schemes = [
  {
    id: 'sparkColors',
    label: 'SPARK Colors',
    colors: [
      '#29696B',
      '#5BCACE',
      '#F4B02A',
      '#C00000',
      '#FFC000',
      '#00B0F0',
      '#91D04E',
      '#ff2121',
      '#ffa631',
      '#3eede7',
      '#bce672',
      '#f00056',
      '#fa8c35',
      '#1685a9',
      '#00bc12',
      '#ff2d51',
      '#ff7500',
      '#065279',
      '#0aa344',
      '#db5a6b',
      '#d9b611',
      '#4b5cc4',
      '#21a675',
      '#c83c23',
      '#e29c45',
      '#801dae',
      '#3de1ad',
      '#fff143',
      '#cca4e3',
      '#789262',
      '#ff0097',
      '#815476',
      '#7F7F7F',
      '#cb3a56',
    ],
  },
].map(s => new CategoricalScheme(s));

export default schemes;
